import { containerNames } from '../../constants';
import { PixiBase } from '../../core/pixi/PixiBase';
import { userInfoStore } from '../../store/userInfoStore';
import { isMobile } from '../../helpers/isMobile';
import { betBarStore } from '../../store/betBarStore';
import { betButtonContainerXPositionHandler } from '../../helpers/betButtonContainerXPositionHandler';
import { gameMainDrawer } from './gameMainDrawer';
import { updateBetAmountButtonsState } from '../../helpers/betButtonStates';

import { gameStore } from '../../store/gameStore';
import { setTranslationValues } from '../../core/helpers';
import { applicationStore } from '../../store/applicationStore';
import { addKeyboardListener } from '../../core/helpers/keyboard';
import { spinBarStore } from '../../store/spinBarStore';
import { gambleStore } from '../../store/gambleStore';

export class FreeBetDrawer {
  constructor() {
    this.animations = {};
    this.lister = null;
    this.FreeBetContainer = PixiBase.createContainer(containerNames.FreeBetContainer);
  }

  setupFreeBetPopup() {
    this.freeBetPopupContainer = PixiBase.createContainer(containerNames.freeBetPopupContainer);
    this.freeBetPopupContainer.visible = false;
    const { x, y, scale } = this.config.FreeBetPopupContainerConfig.freeBetPopupContainer;
    this.freeBetPopupContainer.scale.set(scale);
    PixiBase.setPosition(this.freeBetPopupContainer, { x: x, y: y });
    this.popup = PixiBase.createSprite(this.spriteSheet.freeBetPopup);
    this.freeBetPopupBackLayer = PixiBase.createGraphics();
    this.freeBetPopupBackLayer.beginFill(0x000000);
    this.freeBetPopupBackLayer.buttonMode = true;
    this.freeBetPopupBackLayer.interactive = true;
    isMobile()
      ? this.freeBetPopupBackLayer.drawRect(-100, -300, 740, 1200)
      : this.freeBetPopupBackLayer.drawRect(-500, -100, 1920, 1100);
    this.freeBetPopupBackLayer.endFill();
    this.freeBetPopupBackLayer.alpha = 0.65;
    this.freeBetPopupContainer.addChild(this.freeBetPopupBackLayer);
    this.freeBetPopupContainer.addChild(this.popup);
    this.FreeBetContainer.addChild(this.freeBetPopupContainer);
  }

  setupFreeBetButton() {
    this.freeBetButtonContainer = PixiBase.createContainer('freeBetButtonContainer');
    const { x, y } = this.config.FreeBetPopupContainerConfig.freeBetButtonContainer;
    PixiBase.setPosition(this.freeBetButtonContainer, { x: x, y: y });
    this.freeBetButton = PixiBase.createSprite(this.spriteSheet.freeBetOk);
    this.freeBetButtonValue = PixiBase.createText(gameStore.canvasTranslationKeys.OK, {
      fontSize: isMobile() ? 25 : 40,
      align: 'center',
      fill: 'rgba(0,0,0,0.94)',
      fontWeight: 510,
      fontFamily: 'Roboto',
      dropShadow: true,
      dropShadowAngle: 2.4,
      dropShadowDistance: 2,
    });
    PixiBase.setupButtonMode(this.freeBetButtonContainer, { interactive: true, buttonMode: true });
    PixiBase.registerClick(this.freeBetButtonContainer, () => {
      this.freeBetPopupContainer.visible = false;
      if (gambleStore.gambleCount) {
        gameMainDrawer.spinBar.gambleStartButtonContainer.visible = false;
        gameMainDrawer.spinBar.slowSpinButton.visible = true;
      }
      applicationStore.setIsJackPotOpacity(false);
      if (this.freeTotalWinLineRight.visible) {
        spinBarStore.setActiveFreeBetIndex(spinBarStore.activeFreeBetIndex + 1);
        const nextFreeBet = spinBarStore.freeBetList[spinBarStore.activeFreeBetIndex];
        if (spinBarStore.freeBetList.length) {
          if (!betBarStore.quickBetDefaultArr.some((el) => el === betBarStore.selectedAmount)) {
            this.deleteFreeBetAmountFromQuickBets(
              spinBarStore.freeBetList[spinBarStore.activeFreeBetIndex - 1].amount
            );
          }
        }
        if (nextFreeBet) {
          this.nextFreeBetState(nextFreeBet);
        } else {
          spinBarStore.setFreeBetId(null);
          spinBarStore.setFreeBetList([]);
          this.freeTotalWinLineRight.visible = false;
        }
      } else {
        const nextFreeBet = spinBarStore.freeBetList[spinBarStore.activeFreeBetIndex];
        if (nextFreeBet) {
          this.addFreeBetAmountToQuickBets(nextFreeBet.amount);
        }
        gameMainDrawer.spinBar.handleDoSpin();
      }
    });
    this.lister = addKeyboardListener(['Enter', ' '], () => {
      this.freeBetPopupContainer.visible = false;
      if (gambleStore.gambleCount) {
        gameMainDrawer.spinBar.gambleStartButtonContainer.visible = false;
        gameMainDrawer.spinBar.slowSpinButton.visible = true;
      }
      applicationStore.setIsJackPotOpacity(false);
      if (this.freeTotalWinLineRight.visible) {
        spinBarStore.setActiveFreeBetIndex(spinBarStore.activeFreeBetIndex + 1);
        const nextFreeBet = spinBarStore.freeBetList[spinBarStore.activeFreeBetIndex];
        if (spinBarStore.freeBetList.length) {
          if (!betBarStore.quickBetDefaultArr.some((el) => el === betBarStore.selectedAmount)) {
            this.deleteFreeBetAmountFromQuickBets(
              spinBarStore.freeBetList[spinBarStore.activeFreeBetIndex - 1].amount
            );
          }
        }

        if (nextFreeBet) {
          this.nextFreeBetState(nextFreeBet);
        } else {
          spinBarStore.setFreeBetId(null);
          spinBarStore.setFreeBetList([]);
          this.freeTotalWinLineRight.visible = false;
        }
        // this.lister && this.lister();
      } else if (!gameStore.isOpenBigWinPopup) {
        if (spinBarStore.isSpinStart) {
          spinBarStore.setIsDoubleClick(true);
          return;
        }
        if (spinBarStore.isAutoBetStart) {
          return;
        }
        const nextFreeBet = spinBarStore.freeBetList[spinBarStore.activeFreeBetIndex];
        if (nextFreeBet) {
          this.addFreeBetAmountToQuickBets(nextFreeBet.amount);
        }
        gameMainDrawer.spinBar.handleDoSpin();
      }
    });
    this.freeBetButtonValue.x = 140;
    this.freeBetButtonValue.y = 45;
    this.freeBetButtonValue.anchor.set(0.5);
    this.freeBetButtonContainer.addChild(this.freeBetButton);
    this.freeBetButtonContainer.addChild(this.freeBetButtonValue);
    this.freeBetPopupContainer.addChild(this.freeBetButtonContainer);
  }

  nextFreeBetState(nextFreeBet) {
    gameMainDrawer.freeBetBar.freeBetPopupContainer.visible = true;
    gameMainDrawer.freeBetBar.freeBetCountContainer.visible = true;
    gameMainDrawer.betBar.increaseWinAndLastWinContainerPositionByFreeBet();
    spinBarStore.setFreeBetId(nextFreeBet.id);
    betBarStore.setFreeBetSelectedAmount(nextFreeBet.amount);
    gameMainDrawer.freeBetBar.updateFreeBetCount(nextFreeBet.remainingCount);
    gameMainDrawer.freeBetBar.updateFreeBetPopupTexts(
      gameStore.canvasTranslationKeys.CONGRATULATIONS_4,
      setTranslationValues(gameStore.canvasTranslationKeys.FREE_SPINS_BONUS, {
        VALUE: nextFreeBet.remainingCount,
      }),
      gameStore.canvasTranslationKeys.PLAY,
      '',
      false
    );
    this.addFreeBetAmountToQuickBets(nextFreeBet.amount);
  }

  setupWinAmount() {
    const { currencySymbolOrCode } = userInfoStore;
    this.winWinAmount = PixiBase.createText(`0 ${currencySymbolOrCode}`, {
      fontSize: isMobile() ? 40 : 50,
      align: 'center',
      fill: '#f5c000',
      fontWeight: 510,
      fontFamily: 'Roboto',
      dropShadow: true,
      dropShadowAngle: 2.4,
      dropShadowDistance: 2,
    });
    const { x, y, anchor } = this.config.FreeBetPopupContainerConfig.freeBetWinAmountConfig;
    PixiBase.setPosition(this.winWinAmount, { x: x, y: y });
    this.winWinAmount.anchor.set(anchor);
    this.freeBetPopupContainer.addChild(this.winWinAmount);
  }

  setupTotalWinHeader() {
    this.freeBetHeaderContainer = PixiBase.createContainer('freeBetHeaderContainer');
    this.totalWinHeader = PixiBase.createText(gameStore.canvasTranslationKeys.TOTAL_WIN, {
      fontSize: isMobile() ? 20 : 30,
      align: 'center',
      fill: '#f5c000',
      fontWeight: 510,
      fontFamily: 'Roboto',
      dropShadow: true,
      dropShadowAngle: 2.4,
      dropShadowDistance: 2,
    });
    const { x, y, anchor } = this.config.FreeBetPopupContainerConfig.freeBetTotalWinHeader;
    PixiBase.setPosition(this.totalWinHeader, { x: x, y: y });
    this.totalWinHeader.anchor.set(anchor);
    this.youHave = PixiBase.createText(gameStore.canvasTranslationKeys.BONUS_ROUND_POPUP, {
      fontSize: isMobile() ? 20 : 26,
      align: 'center',
      fill: '#FFFFFF',
      fontWeight: 510,
      fontFamily: 'Roboto',
      wordWrap: true,
      wordWrapWidth: isMobile() ? 270 : 330,
    });
    this.youHave.y = isMobile() ? 150 : 215;
    this.youHave.x = isMobile() ? 260 : 400;
    this.youHave.anchor.set(anchor);
    this.freeTotalWinLineLeft = PixiBase.createSprite(this.spriteSheet.freeBetLine);
    this.freeTotalWinLineLeft.x = isMobile() ? 0 : 180;
    this.freeTotalWinLineLeft.y = isMobile() ? 0 : 320;
    this.freeTotalWinLineRight = PixiBase.createSprite(this.spriteSheet.freeBetLine);
    this.freeTotalWinLineRight.visible = false;

    this.freeTotalWinLineRight.scale = { x: -1, y: 1 };
    this.freeTotalWinLineRight.x = isMobile() ? 0 : 585;
    this.freeTotalWinLineRight.y = this.freeTotalWinLineLeft.y;
    this.freeBetHeaderContainer.addChild(this.youHave);
    this.freeBetHeaderContainer.addChild(this.totalWinHeader);
    this.freeBetHeaderContainer.addChild(this.freeTotalWinLineLeft);
    this.freeBetHeaderContainer.addChild(this.freeTotalWinLineLeft);
    this.freeBetHeaderContainer.addChild(this.freeTotalWinLineRight);
    this.freeBetPopupContainer.addChild(this.freeBetHeaderContainer);
  }

  toggleVisibilityFreeBetCountContainer(bool) {
    this.freeBetCountContainer.visible = bool;
  }

  setupFreeBetCountHeader() {
    this.freeBetCountContainer = PixiBase.createContainer('freeBetCountContainer');
    this.freeBetCountContainer.visible = false;
    const min = isMobile() ? 0 : 480;
    const max = isMobile() ? 540 : 1000;
    const { x, y } = this.config.FreeBetPopupContainerConfig.freeBetCountHeader;
    PixiBase.setPosition(this.freeBetCountContainer, { x: x, y: y });
    this.freeBetCountHeader = PixiBase.createText(
      setTranslationValues(gameStore.canvasTranslationKeys.FREE_SPINS_LEFT, { VALUE: '' }),
      {
        fontSize: isMobile() ? 24 : 19,
        fill: '#FFFFFF',
        align: 'center',
        fontWeight: 500,
        fontFamily: 'Roboto',
      }
    );
    this.freeBetCountContainer.addChild(this.freeBetCountHeader);
    PixiBase.setPosition(this.freeBetCountContainer, {
      x: min + (max - min - this.freeBetCountContainer.width) / 2,
      y: this.freeBetCountContainer.y,
    });
    this.FreeBetContainer.addChild(this.freeBetCountContainer);
  }

  updateFreeBetCount(count) {
    this.freeBetCountHeader.text = setTranslationValues(
      gameStore.canvasTranslationKeys.FREE_SPINS_LEFT,
      {
        VALUE: count,
      }
    );
  }

  // eslint-disable-next-line default-param-last
  updateFreeBetPopupTexts(textYouHave, textTotalWin, buttonText, winAmount = 0, boolValue) {
    const { currencySymbolOrCode } = userInfoStore;
    this.youHave.text = textYouHave;
    if (boolValue) {
      this.youHave.scale.set(1);
      this.totalWinHeader.scale.set(1);
      this.totalWinHeader.y = isMobile() ? 220 : 320;
    } else {
      this.youHave.scale.set(1.5);
      this.totalWinHeader.scale.set(1.5);
      this.totalWinHeader.y = isMobile() ? 220 : 320;
    }
    this.totalWinHeader.text = textTotalWin;
    this.winWinAmount.text = `${winAmount} ${boolValue ? currencySymbolOrCode : ''}`;
    this.freeBetButtonValue.text = buttonText;
    this.freeTotalWinLineLeft.visible = boolValue;
    this.freeTotalWinLineRight.visible = boolValue;
  }

  updateFreeBetSelectedAmount(boolValue) {
    betBarStore.quickBetArr.forEach((betAmount, index) => {
      if (betAmount === betBarStore.freeBetSelectedAmount) {
        betButtonContainerXPositionHandler(index);
        updateBetAmountButtonsState(betAmount, true);
      } else if (gameMainDrawer.betBar.betButtonContainer.children[index]) {
        gameMainDrawer.betBar.betButtonContainer.children[index].interactive = boolValue;
        gameMainDrawer.betBar.betButtonContainer.children[index].buttonMode = boolValue;
      }
    });
  }

  deleteFreeBetAmountFromQuickBets(freeBetAmount) {
    const { quickBetArr } = betBarStore;
    const newQuickBetArr = quickBetArr.filter((el) => el !== freeBetAmount);
    const selectedAmountIndex = newQuickBetArr.findIndex(
      (el) => el === betBarStore.defaultBetAmount
    );
    betBarStore.setSelectedAmount(betBarStore.defaultBetAmount);
    betBarStore.setQuickBetArr(newQuickBetArr);
    gameMainDrawer.betBar.updateQuickBets();
    betButtonContainerXPositionHandler(selectedAmountIndex);
  }

  addFreeBetAmountToQuickBets(freeBetAmount) {
    const { quickBetArr } = betBarStore;
    const isCustomAmount = betBarStore.quickBetArr.every((el) => el !== freeBetAmount);
    let quickBetsWithFreeBet = quickBetArr;
    if (isCustomAmount) {
      quickBetsWithFreeBet = quickBetArr.reduce((acc, current, index) => {
        if (current <= freeBetAmount && quickBetArr[index + 1] >= freeBetAmount) {
          acc.push(current);
          acc.push(freeBetAmount);
        } else {
          acc.push(current);
        }
        return acc;
      }, []);
    }
    betBarStore.setSelectedAmount(freeBetAmount);
    betBarStore.setQuickBetArr(quickBetsWithFreeBet);
    const selectedAmountIndex = quickBetsWithFreeBet.findIndex((el) => el === freeBetAmount);
    betBarStore.setSelectedBetAmountIndex(selectedAmountIndex);
    gameMainDrawer.betBar.updateQuickBets();
    betButtonContainerXPositionHandler(selectedAmountIndex);
  }

  startFreeBetPopup(userActiveFreeBets, tournamentInfo = null) {
    const count = tournamentInfo?.tournamentId
      ? tournamentInfo?.freeBetCount
      : userActiveFreeBets[0].remainingCount;
    gameMainDrawer.betBar.increaseWinAndLastWinContainerPositionByFreeBet();
    if (!tournamentInfo?.tournamentId) {
      spinBarStore.setFreeBetList(userActiveFreeBets);
      spinBarStore.setFreeBetId(userActiveFreeBets[0].id);
    }
    const amount = tournamentInfo?.tournamentId
      ? tournamentInfo?.freeBetPGCoinAmount
      : userActiveFreeBets[0].amount;
    // this.addFreeBetAmountToQuickBets(amount);
    betBarStore.setFreeBetSelectedAmount(amount);
    gameMainDrawer.freeBetBar.freeBetPopupContainer.visible = true;
    gameMainDrawer.freeBetBar.freeBetCountContainer.visible = true;
    gameMainDrawer.freeBetBar.updateFreeBetCount(count);
    applicationStore.setIsJackPotOpacity(true);
    gameMainDrawer.freeBetBar.updateFreeBetPopupTexts(
      gameStore.canvasTranslationKeys.CONGRATULATIONS_4,
      setTranslationValues(gameStore.canvasTranslationKeys.FREE_SPINS_BONUS, {
        VALUE: count,
      }),
      gameStore.canvasTranslationKeys.PLAY,
      '',
      false
    );
  }

  execute(config, spriteSheet) {
    const [gameImageSpriteSheet] = spriteSheet;
    this.config = config;
    this.spriteSheet = gameImageSpriteSheet;
    this.setupFreeBetCountHeader();
    this.setupFreeBetPopup();
    this.setupFreeBetButton();
    this.setupWinAmount();
    this.setupTotalWinHeader();
  }
}
